import { JSX } from "react";

import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import notFound from "../assets/images/notFound.svg";

const styles = {
  notFoundContainer: { minHeight: "100vh" },
};

function NotFound(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Grid
      container
      className='notFound__container'
      direction='column'
      alignItems='center'
      justifyContent='center'
      sx={styles.notFoundContainer}
    >
      <Grid>
        <h2 className='notFound__title'>{t("notFoundMsg")}</h2>
      </Grid>
      <Grid>
        <Link to='/'>
          <Button variant='contained' color='primary' size='large'>
            {t("backToHome")}
          </Button>
        </Link>
      </Grid>
      <Grid>
        <img src={notFound} alt='404 page' />
      </Grid>
    </Grid>
  );
}

export default NotFound;
